/*
 * @Author: lijing
 * @Date: 2022-08-31 16:52:02
 * @Last Modified by: lijing
 * @Last Modified time: 2022-11-11 14:27:27
 */
import React, { FC, useEffect, useState } from "react";
import {
  Form,
  Select,
  Space,
  Button,
  Input,
  Table,
  Modal,
  message,
  Row,
  Col,
} from "antd";
import type { ColumnsType } from "antd/es/table";
import { EditorLive } from "@root/components/editorLive/index";
import { CoursePreview } from "@root/components/coursePreview/index";
import { useSelector } from "react-redux";
import { RootState } from "@root/store";
import SubjectSelect from "@root/components/selectBox/subjectSelect";
import {
  liveList,
  selectTag,
  liveInfo,
  liveStatus,
  liveDelete,
  getLiveSummaryInfo,
  querySpecialClassificationDataByLive,
} from "@root/common/service";

const { Option } = Select;

interface DataType {
  auditStatus: number;
  auditStatusText: string;
  centerCategoryInfo: string;
  clickCount: number;
  content: string;
  createBy: string;
  createTime: string;
  createTimeText: string;
  id: number;
  image: string;
  imageAllPath: string;
  instituteId: number;
  introduction: string;
  name: string;
  originalImage: string;
  originalImageAllPath: string;
  showOrder: number;
  status: number;
  statusText: string;
  subjectInfo: string;
  tagInfo: string;
  type: number;
  updateTime: string;
  updateTimeText: string;
  userType: string;
  waterMark: number;
  /**是否置顶 */
  topStatus: 1 | 2;
}

interface ISummaryInfoProp {
  totalCount: number;
  upCount: number;
  downCount: number;
  unAuditCount: number;
  passCount: number;
  unPassCount: number;
}

export const LiveList: FC = () => {
  const { subjectData, centerClassification } = useSelector(
    (state: any) => state.directionaries
  );
  const { baseUserCategory, isCountyProject } = useSelector(
    (state: RootState) => state.userInfo
  );
  const [treeData, setTreeData] = useState([]);
  const columns: ColumnsType<DataType> = [
    {
      title: "",
      dataIndex: "imageAllPath",
      key: "imageAllPath",
      render(text, data) {
        return <img height="70" src={text} alt="" />;
      },
    },
    {
      title: "直播名称",
      dataIndex: "name",
      key: "name",
      render(text, data) {
        return (
          <div
            onClick={() => {
              onPreviewClickHandle(data.id);
            }}
          >
            <div>{text}</div>
          </div>
        );
      },
    },
    {
      title: "直播分类",
      dataIndex: "categoryInfo",
      key: "categoryInfo",
    },
    {
      title: "直播开始时间",
      dataIndex: "startTime",
      key: "startTime",
    },
    {
      title: "状态",
      dataIndex: "statusText",
      key: "statusText",
    },
    {
      title: "观看人次",
      dataIndex: "clickCount",
      key: "clickCount",
      render(text, data) {
        return <span>{text}次</span>;
      },
    },
    {
      title: "操作",
      key: "address",
      render: (_, record) => (
        <Space>
          <Button
            type="link"
            onClick={() => {
              onEditClickHandle(record);
            }}
          >
            编辑
          </Button>
          <Button
            type="link"
            onClick={() => {
              onStatusClickHandle([record.id], record.status === 1 ? 0 : 1);
            }}
          >
            {record.status === 1 ? "下架" : "上架"}
          </Button>
          <Button
            type="link"
            onClick={() => {
              onDeleteClickHandle(record.id);
            }}
          >
            删除
          </Button>
        </Space>
      ),
    },
  ];

  // 判断：是否显示审核状态和审核意见
  if (
    baseUserCategory === "13" ||
    baseUserCategory === "12" ||
    baseUserCategory === "19"
  ) {
    columns.splice(columns.length - 1, 0, {
      title: "审核状态",
      dataIndex: "auditStatusText",
      key: "auditStatusText",
    });
    columns.splice(columns.length - 1, 0, {
      title: "审核意见",
      dataIndex: "returnReason",
      key: "returnReason",
    });
  }

  const [iseditorCourseVisible, setIseditorCourseVisible] = useState(false);
  const [isCoursePreviewVisible, setIsCoursePreviewVisible] = useState(false);
  const [curoseList, setCuroseList] = useState<DataType[]>([]);
  const [tableLoading, setTableLoading] = useState(false);
  const [tableTotal, setTableTotal] = useState(1);
  const [tablePageNum, setTablePageNum] = useState(1);
  const [editInfo, setEditInfo] = useState<any>(null);
  const [tagList, setTagList] = useState([]);
  const [selectCourse, setSelectCourse] = useState<React.Key[]>([]);
  const [previewId, setPreviewId] = useState(0);
  const [summaryInfo, setSummartInfo] = useState<ISummaryInfoProp | null>(null);
  const [form] = Form.useForm();

  const onSearchClickHandle = () => {
    getCourseList(1);
  };

  const onResetClickHandle = () => {
    form.resetFields();
    getCourseList(1);
  };

  const onCreateClickHandle = () => {
    setIseditorCourseVisible(true);
  };

  const getCourseList = async (page = tablePageNum) => {
    const params = form.getFieldsValue(true);

    setTableLoading(true);
    setTablePageNum(page);
    liveList({ pageNum: page, pageSize: 10 }, { ...params })
      .then((res: any) => {
        const {
          data: { rows, total },
        } = res;
        setCuroseList(rows);
        setTableTotal(total);
        setSelectCourse([]);
      })
      .finally(() => {
        setTableLoading(false);
      });
  };

  const onEditClickHandle = async (data: DataType) => {
    liveInfo(data.id).then((res) => {
      setEditInfo(res.data);
      setIseditorCourseVisible(true);
    });
  };
  /**
   * 获取专项分类数据
   */
  const getSpecialClassificationData = async () => {
    const { data = [] } = await querySpecialClassificationDataByLive();
    setTreeData(data);
  };
  useEffect(() => {
    getSpecialClassificationData();
  }, []);
  const onStatusClickHandle = async (data: React.Key[], status: number) => {
    liveStatus({
      liveIdList: data,
      status: status,
    }).then((res) => {
      message.success("操作成功");
      getCourseList();
    });
  };

  const onPreviewClickHandle = (id: number) => {
    setPreviewId(id);
    setIsCoursePreviewVisible(true);
  };

  const onDeleteClickHandle = (id: number) => {
    Modal.confirm({
      title: "删除确认",
      content: "您确定删除吗？",
      okText: "确认",
      cancelText: "取消",
      onOk() {
        return new Promise((resolve, reject) => {
          liveDelete(id).then(() => {
            getCourseList();
            resolve("删除成功");
          });
        }).catch(() => console.log("Oops errors!"));
      },
    });
  };

  useEffect(() => {
    getCourseList();

    selectTag().then((res) => {
      setTagList(res.data);
    });

    getLiveSummaryInfo().then((res) => {
      setSummartInfo(res.data);
    });
  }, []);

  useEffect(() => {
    if (iseditorCourseVisible === false) {
      setEditInfo(null);
    }
  }, [iseditorCourseVisible]);

  return (
    <div className="coursemanage-list">
      <div className="coursemanage-form-title">
        <Form
          name="customized_form_controls"
          layout="inline"
          form={form}
          labelCol={{ span: 6 }}
          wrapperCol={{ span: 18 }}
        >
          <Row gutter={32}>
            <Col span={8}>
              <Form.Item name="liveId" label="直播ID">
                <Input />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item name="name" label="直播名称">
                <Input />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item name="categoryId" label="直播分类">
                <Select>
                  {treeData.map((item: any) => {
                    return <Option value={item.key}>{item.title}</Option>;
                  })}
                </Select>
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item name="status" label="状态">
                <Select>
                  <Option value={1}>上架</Option>
                  <Option value={0}>下架</Option>
                </Select>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </div>
      <div className="coursemanage-form-btns">
        <Space>
          <Button
            type="primary"
            onClick={() => {
              onSearchClickHandle();
            }}
          >
            查询
          </Button>
          <Button
            type="primary"
            onClick={() => {
              onResetClickHandle();
            }}
          >
            重置
          </Button>
        </Space>
      </div>
      <div className="coursemanage-option">
        <div className="coursemanage-option-total">
          {summaryInfo &&
            `总数量(${summaryInfo.totalCount}条) 上架数量(${summaryInfo.upCount}条) 下架数量(${summaryInfo.downCount}条)`}
        </div>
        <div className="coursemanage-option-btns">
          <Space>
            <Button
              type="primary"
              onClick={() => {
                onStatusClickHandle(selectCourse, 1);
              }}
            >
              批量上架
            </Button>
            <Button
              type="primary"
              onClick={() => {
                onStatusClickHandle(selectCourse, 0);
              }}
            >
              批量下架
            </Button>
            <Button
              type="primary"
              onClick={() => {
                onCreateClickHandle();
              }}
            >
              新建直播
            </Button>
          </Space>
        </div>
      </div>
      <div className="coursemanage-table">
        <Table
          rowKey="id"
          loading={tableLoading}
          rowSelection={{
            type: "checkbox",
            selectedRowKeys: selectCourse,
            onChange: (array) => {
              setSelectCourse(array as number[]);
            },
          }}
          columns={columns}
          dataSource={curoseList}
          pagination={{
            total: tableTotal,
            onChange: (page) => {
              getCourseList(page);
            },
            showTotal: (total) => {
              return "共" + total + "条记录";
            },
          }}
        />
      </div>
      {iseditorCourseVisible && (
        <EditorLive
          liveDetail={editInfo}
          getCourseList={getCourseList}
          setIseditorCourseVisible={setIseditorCourseVisible}
          treeData={treeData || []}
        />
      )}
      {isCoursePreviewVisible && (
        <CoursePreview
          previewId={previewId}
          setIsCoursePreviewVisible={setIsCoursePreviewVisible}
        />
      )}
    </div>
  );
};
